import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ModalAlert.css';
import BodyScroll from '../BodyScroll';

const onCloseWrapper = ({ _onClose, onClose }) => {
  _onClose();
  if (typeof onClose === 'function') {
    onClose();
  }
};

const ModalAlert = props => {
  const { title, body, onClose, _onClose, buttonLabel, onButtonClick } = props;
  return (
    <div className="modal-skp">
      <BodyScroll isScroll />
      <div className="modal-skp__content anim-modal text-center">
        <button className="btn btn--modal-close" onClick={() => _onClose()}>
          <i className="fa fa-times" aria-hidden="true" />
        </button>
        {title &&
          <h3 className={s.title}>
            {title}
          </h3>}
        {body &&
          <div className={s.body}>
            {body}
          </div>}
        <button
          className="btn btn--large btn--filled btn--rounded"
          onClick={() =>
            typeof onButtonClick === 'function'
              ? onButtonClick()
              : onCloseWrapper({ onClose, _onClose })}
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
};

ModalAlert.propTypes = {
  // passed through ModalController
  _onClose: PropTypes.func.isRequired,
  // passed in by alert action caller
  title: PropTypes.node,
  body: PropTypes.node,
  buttonLabel: PropTypes.node,
  onButtonClick: PropTypes.func,
  onClose: PropTypes.func,
};

ModalAlert.defaultProps = {
  title: null,
  body: null,
  buttonLabel: 'Close',
  onButtonClick: null,
  onClose: null,
};

export default withStyles(s)(ModalAlert);



// WEBPACK FOOTER //
// ./src/components/ModalAlert/ModalAlert.js